import axios from "../axios"

const getEmployeesByDepartmentId = (id) => {
    return axios
        .get(`/division/employee/${id}`)
        .then(response => response.data)
}

const getDebugEmployeesByDepartmentId = (id) => {
    return axios
        .get(`/debug/employee-list/${id}`)
        .then(response => response.data)
}

const statistics = () => {
    return axios.get(`/docflow/statistics`)
        .then(response => response.data)
}

const getManagersByDepartmentId = (id) => {
    return axios
        .get(`/division/department/${id}/managers`)
        .then(response => response.data)
}

export default {
    getEmployeesByDepartmentId,
    getDebugEmployeesByDepartmentId,
    statistics,
    getManagersByDepartmentId,
};